import { useCallback } from "react";

const useWsPostMessageEffects = ({
  logAction,
  setIsLoading,
  setIsWaitingResponse,
  setIsMessageInputEnabled,
  setIsProcessing,
  inputRef,
}) => {
  return useCallback((data) => {
    logAction("RECEIVED_MESSAGE", {
      messageType: data.type,
      role: data.role,
      projectState: data.project_state || null,
    });

    setIsLoading(false);
    setIsWaitingResponse(false);
    setIsMessageInputEnabled(true);
    setIsProcessing(false);

    if (inputRef.current) {
      setTimeout(() => {
        inputRef.current?.focus();
      }, 100);
    }
  }, [
    inputRef,
    logAction,
    setIsLoading,
    setIsMessageInputEnabled,
    setIsProcessing,
    setIsWaitingResponse,
  ]);
};

export default useWsPostMessageEffects;
